import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const NavbarButton = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  border: 1px solid #315254;
  color: #315254;
  background: #fff;
  min-width: max-content;
  cursor: pointer;
  transition: all 0.5;
  &:hover {
    border-radius: 24px;
    border: 1px solid #315254;
    background: #315254;
    color: white;
  }
`

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const NavbarLogin = ({ setUserFlowMode, setShowUserModal }) => {
  const handleLoginClick = event => {
    event.preventDefault()
    setUserFlowMode("LOGIN")
    setShowUserModal(true)
  }

  return (
    <ItemWrapper>
      <NavbarButton onClick={handleLoginClick}>Log in</NavbarButton>
    </ItemWrapper>
  )
}

NavbarLogin.propTypes = {
  setUserFlowMode: PropTypes.func.isRequired,
  setShowUserModal: PropTypes.func.isRequired,
}
export default NavbarLogin
